<template>
  <div id="floatingPlaten"  class="page-content">
    <el-breadcrumb separator="/" >
      <el-breadcrumb-item>活动信息</el-breadcrumb-item>
      <el-breadcrumb-item>活动模板</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="page">
      <el-row style="margin-bottom: 8px;">
        <el-col :span="24">
          <el-button type="primary" @click="oneStep(1)" style="margin-right: 10px;" size="small">新建活动模板</el-button>
        </el-col>
      </el-row>

      <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%">
        <el-table-column label="序号" min-width="10%">
          <template slot-scope="scope">
            {{scope.$index+1}}
          </template>
        </el-table-column>
        <el-table-column prop="templatename" label="模板名称" min-width="55%">
          <template slot-scope="scope">
            <span @click="oneStep(scope.row)" style="color: #409EFF;cursor: pointer;">
              {{scope.row.templatename}}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="productcount" label="申报方式" show-overflow-tooltip  min-width="20%">
					<template slot-scope="scope">
            <span>{{ scope.row.declaremeans === '0' ? '按产品申报' : '按链接申报' }} </span>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="15%">
          <template slot-scope="scope">
            <el-button type="text" icon="el-icon-delete" @click="delect(scope.row.id,scope.row.templatename)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <div v-show="tableData.length > 0">
        <pagination
          :currentPage="currentPage" :pageSizes="[10, 20, 50, 100]"
          :total="totalNum" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange">
        </pagination>
      </div>
    </div>
    <!-- 删除 -->
    <el-dialog title="提示" :visible.sync="delectShow" width="20%" style="margin-top: 10%;" id="dialog">
        <div style="display: flex;width: 100%;justify-content:center;">
            <i class="el-icon-warning" style="color:#faad14;font-size: 35px;"></i>
           <div>
               <div style="font-size: 16px;">你确认要删除【{{templatename}}】吗？</div>
               <div style="font-size: 14px;">删除后
               <span style="color: #e90e24;font-size: 14px;">该模板无法找回，只能重新创建</span>
            </div>
           </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="sureDelect()" size="small">确 定</el-button>
          <el-button @click="delectShow = false" style="margin-left: 10px;" size="small" type="TheCustom">取 消</el-button>
        </span>
    </el-dialog>
    <!-- 删除 -->
  </div>
</template>

<script>
  import pagination from "../../../components/dataTable/pagination";
  export default {
    data() {
      return {
        delectShow: false,
        tableData: [],
        pageNo: 1,
        pageSize: 10,
        currentPage: 1,
        totalNum: 100,
        id: '',
        templatename: '',
      }
    },
    mounted() {
      this.getcampaignTemplatemainlist()
    },
    methods: {
      oneStep(e) {
        if (e==1) {
          this.$router.push({
            path: '/addMain',
            query: {sureShow: 'true'}
          })
        } else {
					const id = e.id;
					const mode = e.declaremeans;
          this.$router.push({
            path: '/addMain',
            query: {id, mode}
          })
        }
      },
      delect(e,f) {
        this.id = e
        this.templatename = f
        this.delectShow = true
      },
      sureDelect() {
        let params={
          id: this.id
        }
        fetch({
          url: "/hcm/campgign/delectCampaignTemplatemain",
          method: "post",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.getcampaignTemplatemainlist();
            this.delectShow = false
          }
        })
      },
      handleSizeChange(val) {
        this.pageSize = `${val}`
        this.getcampaignTemplatemainlist();
      },
      handleCurrentChange(val) {
        this.pageNo = `${val}`
        this.getcampaignTemplatemainlist();
      },
      getcampaignTemplatemainlist() {
        let params={
          pageNo: this.pageNo,
          pageSize: this.pageSize,
        }
        fetch({
          url: "/hcm/campgign/getcampaignTemplatemainlist",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            this.tableData = data.content;
            this.totalNum = data.totalElements;
          }
        })
        .catch(err => {

        })
      },
    },
    components: {
      pagination
    }
  }
</script>
<style scoped lang="scss">
  .page {
    padding: 20px;
    margin-top: 10px;
    background-color: white;
    height: 870px;
  }
  .el-button--TheCustom {
    color: #666;
    border-color: #D9D9D9;
    background-color: #fff;
  }
  .el-button--TheCustom:hover  {
    color: #666;
    border-color: #ded2b8;
    background-color: #faf9f5;
  }
</style>
<style lang="scss">
#floatingPlaten {
  .el-table__empty-text{
    padding-top: 100px;
    background: url("../../../assets/img/other/nodata.svg") no-repeat;
    background-position: center 66px;
  }
  .el-table th {
    background-color: #f3f7ff !important;
  }
  .el-table thead {
    color: #333333;
    font-weight: 500;
  }
  .el-dialog__title {
    font-size: 16px;
  }
  #dialog {
    .el-dialog__header {
      padding: 20px 20px 10px;
      border-bottom: 1px solid #d9d9d9;
    }
    .el-button--primary {
      color: #FFF;
      background-color: #bda571;
      border-color: #bda571;
    }
    .el-button--primary:hover {
      color: #FFF;
      background-color: #c0ae8a;
      border-color: #c0ae8a;
    }
  }
  .el-button+.el-button {
    margin-left: 1px;
  }
}
</style>
